import React, { useEffect } from "react";
import Banner from "../components/homeComponents/Banner";
import Banner2 from "../components/homeComponents/Banner2";
import StatsSection from "../components/homeComponents/StatsSection";
import ServicesSection from "../components/homeComponents/Services";
import ProcessSection from "../components/homeComponents/Process";
import AboutSection from "../components/homeComponents/AboutMe";
import PortfolioSection from "../components/homeComponents/Portfolio";
import FaqSection from "../components/homeComponents/FAQ";
import ContactSection from "../components/homeComponents/Contact";
import { createGlobalStyle } from "styled-components";
// import Hero from "../components/homeComponents/Hero";
// import DressCollection from "../components/homeComponents/DressCollection";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Laureta Martini - Make up and Hair - Munchen";
  }, []);
  const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Jost:wght@200;300;400&display=swap');
    *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
    :root {
      --cream:       #F7F3EE;
      --cream-dark:  #EDE7DC;
      --warm-tan:    #C9AA8C;
      --blush:       #D9B8A2;
      --terracotta:  #B87355;
      --mocha:       #7A5C47;
      --ink:         #2E1F14;
      --ink-soft:    #5C4033;
      --gold:        #C49A6C;
      --font-serif:  'Cormorant Garamond', Georgia, serif;
      --font-sans:   'Montserrat', sans-serif;
    }
    html { scroll-behavior: smooth; }
    body {
      background: var(--cream);
      color: var(--ink);
      font-family: var(--font-sans);
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
      overflow-x: hidden;
    }
  `;
  return (
    <div>
      <GlobalStyle />
      <Banner2 />
      <StatsSection />
      <ServicesSection />
      <PortfolioSection />
      <ProcessSection />
      <AboutSection />
      <FaqSection />
      {/* <ContactSection /> */}
    </div>
  );
};

export default Home;
